module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner3-f5e7e1dad37681e41500443cb2f31f97.png";